<template>
  <ControlUnit
    :title="$t('control.panel.color_scheme')"
    :tooltip="$t('control.panel.color_scheme_description')"
  >
    <InputSelect
      :name="unitName"
      :value="currentTheme"
      :options="themes"
      @change="changeHandler"
    />
  </ControlUnit>
</template>

<script>
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';

import { runAllWithData } from '@/helpers/functional';

import useStateController from './useStateController';
import useRouteController from './useRouteController';

import ControlUnit from './ControlUnit.vue';
import InputSelect from './InputSelect.vue';

export default {
  components: {
    ControlUnit,
    InputSelect,
  },
  setup() {
    const unitName = 'theme-type';

    const store = useStore();

    const themes = store.state.control.themes;

    const currentTheme = computed(() => {
      return store.state.control.currentTheme;
    });

    const { changeControlHandler } = useStateController();

    const { setRouteTypeValue, getRouterQueryValue } =
      useRouteController('Control');

    const changeHandler = runAllWithData(
      changeControlHandler,
      setRouteTypeValue
    );

    onMounted(() => {
      const unitQueryValue = getRouterQueryValue(unitName);

      changeControlHandler({
        type: unitName,
        value: unitQueryValue,
      });
    });

    return {
      unitName,
      themes,
      currentTheme,
      changeHandler,
    };
  },
};
</script>
